import { render, staticRenderFns } from "./LargeWhiteboardSessionModal.vue?vue&type=template&id=3c88f08d&scoped=true&"
import script from "./LargeWhiteboardSessionModal.vue?vue&type=script&lang=js&"
export * from "./LargeWhiteboardSessionModal.vue?vue&type=script&lang=js&"
import style0 from "./LargeWhiteboardSessionModal.vue?vue&type=style&index=0&id=3c88f08d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c88f08d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c88f08d')) {
      api.createRecord('3c88f08d', component.options)
    } else {
      api.reload('3c88f08d', component.options)
    }
    module.hot.accept("./LargeWhiteboardSessionModal.vue?vue&type=template&id=3c88f08d&scoped=true&", function () {
      api.rerender('3c88f08d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/whiteboard/LargeWhiteboardSessionModal.vue"
export default component.exports